import { Card, CardContent, Typography } from "@mui/material";
import ActionCardContent from "./ActionCardContent";
import CodeCardContent from "./CodeCardContent";
import DecisionCardContent from "./DecisionCardContent";
import FilterCardContent from "./FilterCardContent";
import FormatCardContent from "./FormatCardContent";
import PlaybookCardContent from "./PlaybookCardContent";
import PromptCardContent from "./PromptCardContent";
import StartCardContent from "./StartCardContent";
import UtilityCardContent from "./UtilityCardContent";
import MissionControlCardContent from "./MissionControlCardContent";

export default function InfoCard({ node, playbook }) {
  let content = <p>{JSON.stringify(node)}</p>;

  if (node.data.type === "utility") {
    content = <UtilityCardContent node={node}></UtilityCardContent>;
  } else if (node.data.type === "playbook") {
    content = <PlaybookCardContent node={node}></PlaybookCardContent>;
  } else if (node.data.type === "action") {
    content = <ActionCardContent node={node}></ActionCardContent>;
  } else if (node.data.type === "filter") {
    content = <FilterCardContent node={node}></FilterCardContent>;
  } else if (node.data.type === "start" || node.data.type === "end") {
    content = <StartCardContent playbook={playbook} node={node}></StartCardContent>;
  } else if (node.data.type === "code") {
    content = <CodeCardContent node={node}></CodeCardContent>;
  } else if (node.data.type === "decision") {
    content = <DecisionCardContent node={node}></DecisionCardContent>;
  } else if (node.data.type === "format") {
    content = <FormatCardContent node={node}></FormatCardContent>;
  } else if (node.data.type === "prompt") {
    content = <PromptCardContent node={node}></PromptCardContent>;
  } else if (node.data.type === "missionControl") {
    content = <MissionControlCardContent node={node}></MissionControlCardContent>
  }

  return (
    <div
      style={{
        marginTop: 10,
        marginRight: 10,
        position: "absolute",
        right: 0,
        top: 0,
        width: 400,
        maxWidth: "100%",
        overflow: "auto",
        zIndex: 1000,
        colorScheme: "dark",
      }}
    >
      <Card>
        <CardContent>
          <span className="PlaybookBlockDesignation">{node.data.type}</span>

          <Typography style={{ marginBottom: "10px" }} variant="subtitle2">
            {node.data.advanced.customName
              ? node.data.advanced.customName
              : node.data.functionName}
          </Typography>
          <div style={{ textAlign: "left", overflow: "auto" }}>{content}</div>
        </CardContent>
      </Card>
    </div>
  );
}
